module.exports = __webpack_public_path__ + "static/media/shopping_shipyard_marker.637af44d.svg";